<template>
<transition name="zoom">
  <div class="invite">
    <!-- <div id="canvasPic" v-if="!imgUrl" ref="imageDom" >
      <img src="@/assets/banner.png" alt="">
      
      <div class="QR_code">
        <img src="https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQEL8TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyOGJnUmNTbm04ZlAxMDAwMHcwNzMAAgQN5fpeAwQAAAAA" alt="">
      </div>
      <div class="test" ><img src="@/assets/taobao6.png"></div>
    </div> -->
    <div id="canvasPic2" >
      <img :src="imgUrl" alt="">
    </div>
    <div class="bottom">长按图片或者扫描二维码分享</div>
  </div>
</transition>
</template>

<script>
// import html2canvas from 'html2canvas'


import {getWeXinQrCode} from '@/api/ownCenter'
export default {
  data(){
    return{
      timer:10000000,
      imgUrl:''
    }
  },

  created(){
    var form = new FormData();
    form.append("userId",this.$store.state.userId);  
    
    this.$toast.loading({
      duration: this.timer,
      message: '加载中...',
      forbidClick: true,
    });
    getWeXinQrCode(form).then(res=>{
      this.imgUrl = res.data
      this.$toast.clear();
    })
    // html2canvas(this.$refs.imageDom).then(canvas => {
    //   this.imgUrl = canvas.toDataURL("image/png"); 
    
    // });

  },

}
</script>

<style  lang="less" scoped>
.invite{
  width: 100vw;
#canvasPic{
    width: 100vw;
    position: relative;
    margin-left: 0;

    height: calc(94vh - 4.8rem);
    img{
      width: 100%;
      height: 100%;
    }
    .test{
      position: absolute;
      bottom: 13vh;
      left: calc(50vw - 1.5rem);
      z-index: 99;
      img{
        width: 3rem;
        height: 3rem;
      }

        z-index: 9999;
    }
  .QR_code{
    width: 100vw;
    img{
      width: 30vw;
      height: 16vh;
    }
    position: absolute;
    bottom: 8.5vh;
    display: flex;
    justify-content: center;
  }
  }
  .bottom{
    width: 100vw;
    height: 6vh;
    background-color:#FFFF00;
    // margin-top: -2px;
    text-align: center;
    font-size: 1.6rem;
    color: rgba(10, 10, 10, 0.6);
    line-height: 6vh;
  }
}
#canvasPic2{
  width: 100vw;
  height: 94vh;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>